<template>
  <div>
    <v-menu :nudge-width="200" offset-y right bottom close-delay="300">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="ml-2">
          <v-avatar :color="$account.color" size="38">
            <span class="white--text">{{ $account.initials }}</span>
          </v-avatar>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar :color="$account.color" size="48">
                <span class="white--text">{{ $account.initials }}</span>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ $account.current.first_name }} {{ $account.current.last_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ $account.current.company }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list dense>
          <template v-for="item in menu.entries">
            <v-list-item :key="item.text" :to="item.to" link>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small color="grey" @click="goToHome">
            {{ $t('web-site') }}
          </v-btn>
          <v-btn text small color="warning" @click="logout">
            {{ $t('actions.disconnection') }}
             <span v-if="$account.isImpersonated">(Admin)</span>
            <v-icon right>mdi-logout</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'AppBarMenu',
  data () {
    return {
      menu: {
        entries: [
          { icon: 'mdi-account', text: this.$t('account'), to: '/account/profile' },
          { icon: 'mdi-cog', text: this.$t('preferences'), to: '/account/preferences' },
          { icon: 'mdi-tune', text: this.$t('subscription'), to: '/account/subscriptions' },
          { icon: 'mdi-code-tags', text: this.$t('api'), to: '/account/api' },
          { icon: 'mdi-credit-card-clock-outline', text: this.$t('billing'), to: '/account/billing' }
        ]
      }
    }
  },
  methods: {
    logout () {
      if (this.$account.isImpersonated) {
        this.$account.depersonate()
          .then(user => {
            this.$ui.success(this.$t('reconnect-as') + ' ' + user.first_name + ' ' + user.last_name + '.')
            this.$router.push('/')
          })
          .catch(error => {
            this.$ui.error(this.$t('change-account') + error)
          })
      } else {
        this.$account.logout()
        this.$router.push('/login')
      }
    },
    goToHome () {
      window.location.href = 'https://check-position.com'
    }
  }
}
</script>

<i18n>
{
	"en": {
		"account": "My account",
		"api": "Api",
		"billing": "Billing",
		"change-account": "Unable to change accounts :",
		"preferences": "Preferences",
		"reconnect-as": "You are now reconnected as",
		"subscription": "Subscriptions",
		"web-site": "Website"
	},
	"es": {
		"account": "Mi cuenta",
		"api": "Api",
		"billing": "Facturación",
		"change-account": "No se puede cambiar de cuenta :",
		"preferences": "Preferencias",
		"reconnect-as": "Ahora está reconectado como",
		"subscription": "Suscripciones",
		"web-site": "Sitio Web"
	},
	"fr": {
		"account": "Mon compte",
		"api": "Api",
		"billing": "Facturation",
		"change-account": "Impossibler de changer de compte : ",
		"preferences": "Préférences",
		"reconnect-as": "Vous êtes maintenant reconnecté en tant que ",
		"subscription": "Abonnements",
		"web-site": "Site web"
	},
	"it": {
		"account": "Il mio account",
		"api": "Api",
		"billing": "Fatturazione",
		"change-account": "Impossibile cambiare account :",
		"preferences": "Preferenze",
		"reconnect-as": "Sei ora riconnesso come",
		"subscription": "Abbonamenti",
		"web-site": "Sito web"
	},
	"pt": {
		"account": "A minha conta",
		"api": "Api",
		"billing": "Faturação",
		"change-account": "Impossível mudar de conta :",
		"preferences": "Preferências",
		"reconnect-as": "Está agora reconectado como",
		"subscription": "Subscrições",
		"web-site": "Site"
	},
	"pl": {
		"account": "Moje konto",
		"api": "Api",
		"billing": "Faktury",
		"change-account": "Nie można zmienić konta :",
		"preferences": "Preferencje",
		"reconnect-as": "Jesteś teraz ponownie połączony jako",
		"subscription": "Subskrypcje",
		"web-site": "Strona internetowa"
	}
}
</i18n>
